import ZenTokenView from "./ZenTokenView";

export default ZenTokenView;